<div class="order-details-screen">
	<!-- HEADER -->
	<div class="od-header">
		<div class="od-header-left">
			<button type="button" class="od-back-btn" (click)="goBack()">
				<i class="fas fa-arrow-left"></i>
			</button>

			<div class="od-header-icon-title">
				<div class="od-logo">
					<i class="fas fa-clipboard-list"></i>
				</div>
				<div>
					<h1 class="od-title">Purchase Log BPL-{{ purchaseLogId }}</h1>
					<p class="od-subtitle">{{ purchaseLog.supplier.name }}</p>
				</div>
			</div>
		</div>

		<div class="od-clock">
			<span>{{ dateTime | date: 'EEE d MMM HH:mm' }}</span>
		</div>
	</div>

	<!-- ORDER INFO STRIP -->
	<div class="od-info-strip">
		<div class="od-info-grid">
			<div class="od-info-block">
			<p class="od-info-label">Expected Date</p>
			<p class="od-info-value">{{ purchaseLog.dueDate | date: 'd MMM YYYY' }}</p>
		</div>

		<div class="od-info-block">
			<p class="od-info-label">Due To</p>
			<p class="od-info-value">{{ siteName }}</p>
		</div>

		<div class="od-info-block">
			<p class="od-info-label">Total Items</p>
			<p class="od-info-value">{{ getTotalItems }} Items</p>
		</div>

		<div class="od-info-block">
			<p class="od-info-label">Order Reference</p>
			<p class="od-info-value">{{ purchaseLog.workReferenceNo }}</p>
		</div>
	</div>
</div>

<!-- MAIN -->
<div class="od-main">
	<div class="od-main-inner">
		<!-- ITEMS HEADER ROW -->
		<div class="od-items-header">
			<div class="od-col-code">Line #</div>
			<div class="od-col-desc">Description</div>
			<div class="od-col-qty">Quantity</div>
			<div class="od-col-unit">Received</div>
			<!-- <div class="od-col-total">Total</div> -->
			<div class="od-col-action">Action</div>
		</div>

		<!-- ITEMS LIST -->
		<div class="od-items-list">
			<div class="od-item-row" *ngFor="let item of lineItems">
				<div class="od-col-code">
					<p class="od-code-text">{{ item.lineNumber }}</p>
				</div>

				<div class="od-col-desc">
					<h3 class="od-item-title">{{ item.lineDescription }}</h3>
					<p class="od-item-subtitle" *ngIf="purchaseLog.purchaseType == 30">W: {{ item.width }} L: {{item.length}} G: {{item.thickness}}</p>
					<p class="od-item-subtitle" *ngIf="purchaseLog.purchaseType == 70">W: {{ item.width }} L: {{item.length}} H: {{item.height}}</p>
				</div>

				<div class="od-col-qty">
					<p class="od-item-value">{{ item.quantity }}</p>
				</div>

				<div class="od-col-unit">
					<p class="od-item-value">{{ item.received }}</p>
				</div>

				<div class="od-col-action">
					<button *ngIf="!beenLogged(item.lineNumber)" type="button" class="od-receive-btn" [ngClass]="{ 'od-notreceive-btn-active': !beenLogged(item.lineNumber), 'od-receive-btn-disabled': beenLogged(item.lineNumber) }" [disabled]="beenLogged(item.lineNumber)" (click)="(enterNotReceived(item))">
						<i class="fas fa-check od-notreceive-icon"></i>
						<span>{{ item.received ? 'Received' : 'Not Received' }}</span>
					</button>
				</div>

				<div class="od-col-action">
					<button type="button" class="od-receive-btn" [ngClass]="{ 'od-receive-btn-active': !beenLogged(item.lineNumber), 'od-receive-btn-disabled': beenLogged(item.lineNumber) }" [disabled]="beenLogged(item.lineNumber)" (click)="(openPalletModal(item))">
						<i class="fas fa-check od-receive-icon"></i>
						<span>{{ beenLogged(item.lineNumber) ? 'Marked' : 'Receive' }}</span>
					</button>
				</div>
			</div>
		</div>

		<!-- ORDER TOTAL / PROGRESS -->
		<section class="od-total-card">
			<div class="od-total-left">
			<div class="od-total-block">
				<p class="od-info-label">Order Status</p>
				<p *ngIf="purchaseLog.orderReceived" class="od-total-value" style="color:#16a34a">RECEIVED</p>
				<p *ngIf="!purchaseLog.orderReceived" class="od-total-value">OUTSTANDING</p>
			</div>

			<div class="od-total-block">
				<p class="od-info-label">Progress</p>
				<div class="od-progress-row">
				<div class="od-progress-bar">
					<div class="od-progress-fill" [ngStyle]="{ width: getProgressPercentage + '%' }"></div>
				</div>
				<span class="od-progress-text">{{ getProgressPercentage }}%</span>
				</div>
			</div>
			</div>

			<div class="od-total-actions">
				<button type="button" class="od-upload-btn" (click)="openUploadModal()">
					<i class="fas fa-upload"></i>
					<span>Upload Document</span>
					<span class="od-upload-badge" *ngIf="uploadedDocumentCount > 0">{{ uploadedDocumentCount }}</span>
				</button>
				<button type="button" class="od-complete-btn" (click)="completePL()" [disabled]="!checkAllLogged()">
					<i class="fas fa-clipboard-check"></i>
					<span>Complete Order</span>
				</button>
			</div>
		</section>
	</div>
</div>

<!-- PALLET DETAILS MODAL -->
<div class="od-modal-backdrop" *ngIf="showPalletModal">
	<div class="od-modal-card">
		<!-- Modal header -->
		<div class="od-modal-header">
			<div class="od-modal-header-left">
				<div class="od-modal-icon-main">
					<i class="fas fa-pallet"></i>
				</div>
				<div>
					<h2 class="od-modal-title">Pallet Details</h2>
					<p class="od-modal-subtitle">{{ palletOrderLabel }}</p>
				</div>
			</div>

			<button type="button" class="od-modal-close-btn" (click)="cancelPalletModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<!-- Modal body -->
		<div class="od-modal-body">
			<!-- Total pallets section -->
			<section class="od-pallet-section">
				<div class="od-pallet-section-header">
					<div class="od-pallet-icon od-pallet-icon-navy">
						<i class="fas fa-boxes"></i>
					</div>
					<div>
						<h3 class="od-pallet-title">Total Pallets Received</h3>
						<p class="od-pallet-subtitle">Enter the total number of pallets delivered</p>
					</div>
				</div>
				<div class="od-pallet-input-card">
					<label class="od-pallet-label">Number of Pallets</label>
					<input type="number" min="1" max="50" step="1" class="od-pallet-number-input" placeholder="Enter number of pallets" [(ngModel)]="totalPallets" (ngModelChange)="onTotalPalletsChange()"/>
				</div>
			</section>

			<!-- Pallet breakdown -->
			<section class="od-pallet-section">
				<div class="od-pallet-section-header">
					<div class="od-pallet-icon od-pallet-icon-orange">
						<i class="fas fa-list-ol"></i>
					</div>
					<div>
						<h3 class="od-pallet-title">Pallet Breakdown</h3>
						<p class="od-pallet-subtitle">Specify items on each pallet</p>
					</div>
				</div>

				<div class="od-pallet-list">
					<div class="od-pallet-empty" *ngIf="!palletFormStarted || pallets.length === 0">
						<i class="fas fa-box-open od-pallet-empty-icon"></i>
						<p>Enter the total number of pallets above to begin</p>
					</div>

					<div class="od-pallet-card" *ngFor="let pallet of pallets">
						<div class="od-pallet-card-header">
							<div class="od-pallet-number-badge">
								<span>{{ pallet.index }}</span>
							</div>
							<h4 class="od-pallet-card-title">Pallet {{ pallet.index }}</h4>
						</div>

						<div class="od-pallet-card-body">
							<label class="od-pallet-card-label">Number of Items</label>
							<input type="number" min="1" max="1000" class="od-pallet-items-input" placeholder="Enter item count" [(ngModel)]="pallet.items" />
						</div>
					</div>
				</div>
			</section>
		</div>

		<!-- Modal footer -->
		<div class="od-modal-footer">
			<button type="button" class="od-modal-btn od-modal-btn-secondary" (click)="cancelPalletModal()">Cancel</button>
			<button type="button" class="od-modal-btn od-modal-btn-primary" [disabled]="!isPalletFormValid" (click)="savePalletDetails()">
				<i class="fas fa-save"></i>
				<span>Save Pallet Details</span>
			</button>
		</div>
	</div>
</div>

<!-- UPLOAD DOCUMENT MODAL -->
<div class="od-modal-backdrop" *ngIf="showUploadModal">
	<div class="od-modal-card">
		<!-- Header -->
		<div class="od-modal-header">
			<div class="od-modal-header-left">
				<div class="od-modal-icon-main">
					<i class="fas fa-upload"></i>
				</div>
				<div>
					<h2 class="od-modal-title">Upload Document</h2>
					<p class="od-modal-subtitle">{{ uploadModalStep === 1 ? 'Enter your PIN to continue' : 'Attach delivery note or PO' }}</p>
				</div>
			</div>
			<button type="button" class="od-modal-close-btn" (click)="closeUploadModal()">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<!-- Body: Step 1 – PIN -->
		<div class="od-modal-body" *ngIf="uploadModalStep === 1">
			<section class="od-pallet-section">
				<div class="od-pallet-section-header">
					<div class="od-pallet-icon od-pallet-icon-navy">
						<i class="fas fa-lock"></i>
					</div>
					<div>
						<h3 class="od-pallet-title">Authorisation Required</h3>
						<p class="od-pallet-subtitle">Enter your supervisor PIN to upload a document</p>
					</div>
				</div>

				<!-- PIN dots -->
				<div class="od-pin-dots">
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 0"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 1"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 2"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 3"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 4"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 5"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 6"></span>
					<span class="od-pin-dot" [class.od-pin-dot-filled]="uploadPin.length > 7"></span>
				</div>

				<p class="od-pin-error" *ngIf="uploadPinError">{{ uploadPinError }}</p>

				<!-- Numeric keypad -->
				<div class="od-pin-pad">
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('1')">1</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('2')">2</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('3')">3</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('4')">4</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('5')">5</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('6')">6</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('7')">7</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('8')">8</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('9')">9</button>
					<button type="button" class="od-pin-btn od-pin-btn-action" (click)="onUploadPinBackspace()">
						<i class="fas fa-backspace"></i>
					</button>
					<button type="button" class="od-pin-btn" (click)="onUploadPinDigit('0')">0</button>
					<button type="button" class="od-pin-btn od-pin-btn-confirm" [disabled]="uploadPin.length < 4" (click)="submitUploadPin()">
						<i class="fas fa-check"></i>
					</button>
				</div>
			</section>
		</div>

		<!-- Body: Step 2 – Warning + File -->
		<div class="od-modal-body" *ngIf="uploadModalStep === 2">
			<!-- Stamped warning -->
			<div class="od-upload-warning">
				<i class="fas fa-exclamation-triangle od-upload-warning-icon"></i>
				<div>
					<p class="od-upload-warning-title">Delivery Notes Must Be Stamped</p>
					<p class="od-upload-warning-text">Ensure the delivery note has been stamped and signed before uploading. Unstamped documents will not be accepted.</p>
				</div>
			</div>

			<section class="od-pallet-section">
				<div class="od-pallet-section-header">
					<div class="od-pallet-icon od-pallet-icon-navy">
						<i class="fas fa-file-image"></i>
					</div>
					<div>
						<h3 class="od-pallet-title">Select Document</h3>
						<p class="od-pallet-subtitle">Choose an image of the delivery note or PO to upload</p>
					</div>
				</div>

				<label class="od-file-label">
					<input type="file" accept="image/*,.pdf" class="od-file-input" (change)="onFileSelected($event)" />
					<div class="od-file-drop" [class.od-file-drop-selected]="uploadFile">
						<i class="fas" [class.fa-cloud-upload-alt]="!uploadFile" [class.fa-file-check]="uploadFile"></i>
						<span *ngIf="!uploadFile">Tap to choose a file</span>
						<span *ngIf="uploadFile">{{ uploadFile.name }}</span>
					</div>
				</label>
			</section>
		</div>

		<!-- Footer -->
		<div class="od-modal-footer">
			<button type="button" class="od-modal-btn od-modal-btn-secondary" (click)="closeUploadModal()" [disabled]="isUploading">Cancel</button>
			<button *ngIf="uploadModalStep === 2" type="button" class="od-modal-btn od-modal-btn-primary" [disabled]="!uploadFile || isUploading" (click)="confirmAndUpload()">
				<i class="fas" [class.fa-upload]="!isUploading" [class.fa-spinner]="isUploading" [class.fa-spin]="isUploading"></i>
				<span>{{ isUploading ? 'Uploading...' : 'Upload Document' }}</span>
			</button>
		</div>
	</div>
</div>
